angular.module('angus.services')
    .factory('settingsViews', function () {
        return {            
            getWidgetSettingsView: function (widgetCode) {
                return ('templates/settings/widgetSettings/{0}.html').format(widgetCode);
            }
        };
    });